import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import {Theme, SnackbarContent, IconButton} from '@material-ui/core/';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import InfoIcon from '@material-ui/icons/Info';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };


const styles = (theme : Theme) => ({
    success: {
        backgroundColor: green[600],
    },
    warning: {
        backgroundColor: amber[700],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});


interface IAlertProps {
    open: boolean;
    message: string;
    onClose?: any;
    type: string;
    classes: any;
    vertical?: 'top' | 'bottom';
}

class Alert extends React.Component<IAlertProps> {
    state = {
        open: this.props.open,
    };

    handleClose = () => {
        this.setState({ open: false });
        this.props.onClose();
    };    

    render() {
        const Icon = (variantIcon as any)[this.props.type];
        return (            
            <div>
                <Snackbar 
                    anchorOrigin={{
                        vertical: this.props.vertical ? this.props.vertical : 'bottom',
                        horizontal: 'center',
                    }}
                    open={this.state.open}
                    autoHideDuration={6000}
                    onClose={this.handleClose} >
                    <SnackbarContent className={this.props.classes[this.props.type]} message={<span id="message-id" className={this.props.classes.message}> <Icon/>{this.props.message}</span>}
                                    action={[<IconButton color="inherit" onClick={this.handleClose}><CloseIcon/></IconButton>]}/>
                </Snackbar>
            </div>
        );
    }

    
    shouldComponentUpdate(nextProps: any, nextState: any) {
        if (nextProps.open != this.state.open) {
            nextState.open = nextProps.open;
        }
        return true;
    }
}

export default withStyles(styles)(Alert);